<template>
  <b-alert
    v-if="optedIn"
    show
    variant="primary"
    class="banner">
    You've opted into sharing your location! You are the blue pulsing marker
  </b-alert>
  <b-alert
    v-else
    show
    variant="danger"
    class="banner">
    <div class="msg">To get the latest pack data and see your current position, please share your GPS location.</div>
    <b-button
      variant="primary"
      @click="clicked"
    >Share My Location</b-button>
  </b-alert>
</template>

<script>
export default {
  name: "LocationBanner",
  computed: {
    optedIn() {
      //player has opted in AND has a location
      return (
        this.$store.state.player.optedIn && this.$store.state.geolocation.lat
      );
    }
  },
  methods: {
    clicked() {
      this.$store.dispatch("player/OPTED_IN");
    }
  }
};
</script>

<style scoped>
.banner {
  margin: 0;
  display: flex;
  justify-items: center;
}

.banner .msg {
  flex-grow: 1;
  flex: 1;
}

.banner > * {
  display: flex;
  flex-direction: column;
  align-self: center;
}
</style>



// WEBPACK FOOTER //
// src/components/LocationBanner.vue